import api from './ApiServices'

export default class UserService {
  static async signup (salutation, name, orgName, email, role, companyType, website, phone) {
    const response = await api(
      `mutation {
        signupHospital( 
          salutation: ${salutation},
          name: "${name}"
          organization: "${orgName}"
          email: "${email}"
          contact:{
            code:"91"
            mobile:"${phone}"
          }
          role: "${role}"
          companyType: "${companyType}"
          website: "${website}"
        )
    }`
    )
    if (response.error !== null) return response
    else {
      const token = response.data.signupHospital
      if (token.verifyToken) {
        localStorage.setItem('verify-token', token.verifyToken)
      } else {
        localStorage.setItem('access-token', token.accessToken)
        localStorage.setItem('refresh-token', token.refreshToken)
      }
      return true
    }
  }

  static async login (email, password) {
    const response = await api(
      `query {
                loginV1(emailOrPhone: "${email}", password: "${password}") {
                    accessToken
                    refreshToken
                    verifyToken
                }
            }`
    )
    if (response.error !== null) return false
    else {
      const token = response.data.loginV1
      if (token.verifyToken) {
        localStorage.setItem('verify-token', token.verifyToken)
      } else {
        localStorage.setItem('access-token', token.accessToken)
        localStorage.setItem('refresh-token', token.refreshToken)
        // localStorage.setItem('tourToken', JSON.stringify({
        //   userOnBoardingStatus: 'no',
        //   userOnBoardingStatuss: 'no'
        // }))
      }
      return true
    }
  }

  static async getUser (call = false) {
    if (UserService.__user && !call) return UserService.__user
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `query {
            withAuth(token: "${accessToken}") {
                userDetails {
                    id
                    name{
                      first
                      full
                    }
                    organizations{
                      organization{
                        id
                        companies{
                          id
                          name
                          logo{
                            url
                          }
                        }
                        name
                        
                      }
                      role{
                        id
                        name
                      }
                    }
                }
            }   
        }`
    )
    if (response.error !== null) return response?.data?.withAuth?.userDetails
    else {
      UserService.__user = response.data.withAuth.userDetails
      return UserService.__user
    }
  }

  static async listBranches () {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `query{
        withAuth(token:"${accessToken}"){
          listBranches{
           id
           jobLocation{
             hospitalName
             branchName
           }
         }
         }
       }`
    )
    if (response.error) {
      return false
    } else {
      return response.data.withAuth.listBranches
    }
  }

  static async listDepartments (branchId) {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `query{
        withAuth(token:"${accessToken}"){
          listDepartments(
            branch: "${branchId}"
          ){
            id
            departmentType{
              name
            }
         }
         }
       }`
    )
    if (response.error) {
      return false
    } else {
      return response.data.withAuth.listDepartments
    }
  }

  static async listDepartment () {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `query{
        withAuth(token:"${accessToken}"){
          listDepartment{
            id
            departmentType{
              id
              name
            }
         }
         }
       }`
    )
    if (response.error) {
      return false
    } else {
      return response.data.withAuth.listDepartment
    }
  }

  static async postTemporaryJob (branch, department, profession, qualification, specialisation, experience, applicants, description, shift, start, end, yearly, monthly) {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `mutation{
        mutationWithAuth(token:"${accessToken}"){
          fabricate{
            postTemporaryJob(
              branch : "${branch}"
              department : "${department}"
              profession  : "${profession}"
              qualification: "${qualification}"
              specialization : "${specialisation}"
              experience:"${experience}"
              applicants:${applicants}
              description:"${description}"
              shift:${shift}
              start:"${start}"
              end:"${end}"
              yearly:${yearly}
              monthly:${monthly}
            )
          }
        }
      }`
    )
    if (response.error) {
      return false
    } else {
      return response.data.mutationWithAuth.fabricate.postTemporaryJob
    }
  }

  static async getMinJobRate (branch, department, profession, qualification, specialisation, experience) {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `query{
        withAuth(token:"${accessToken}"){
          getMiniJobRate ( 
            branch: "${branch}"
            department: "${department}"
            profession: "${profession}"
            qualification: "${qualification}"
            specialization: "${specialisation}"
            experience: "${experience}"
          )
         }
       }`
    )
    if (response.error) {
      return false
    } else {
      return response.data.withAuth.getMiniJobRate
    }
  }

  static async getMiniJobCost (branch, department, profession, qualification, specialisation, experience, maxRate, applicants, days, shift) {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `query{
        withAuth(token:"${accessToken}"){
          getMiniJobCost ( 
            branch: "${branch}"
            department: "${department}"
            profession: "${profession}"
            qualification: "${qualification}"
            specialization: "${specialisation}"
            experience: "${experience}"
            maxRate: ${maxRate}
            applicants: ${applicants}
            shift: ${shift}
            days: ${days}
          )
          {
            shift
            nurse
            hospital
            margin
            gst
            total
          }
         }
       }`
    )
    if (response.error) {
      return false
    } else {
      return response.data.withAuth.getMiniJobCost
    }
  }

  static async postMiniJob (branch, department, profession, qualification, specialisation, experience, applicants, maxRate, JD, startDate, endDate, shift, days, jobType, isFood, isAccommodation, isTransport, email, contact) {
    const accessToken = localStorage.getItem('access-token')
    // const timing = {
    //   type: jobType,
    //   start: startDate,
    //   end: endDate,
    //   shift: shift,
    //   weekdays: days
    // }
    if (!accessToken) return false
    // timing: ${JSON.stringify(timing).replace(/"(\w+)"\s*:/g, '$1:')}
    // console.log('=====', email, contact)
    const response = await api(
      `mutation{
        mutationWithAuth(token:"${accessToken}"){
          fabricate{
            postMiniJob(
            branch: "${branch}"
            department: "${department}"
            profession: "${profession}"
            qualification: "${qualification}"
            specialization: "${specialisation}"
            experience: "${experience}"
            maxRate: ${maxRate}
            applicants: ${applicants}
            description: "${JD}"
            timing: {
              type: ${jobType},
              start: "${startDate}",
              end: "${endDate}",
              shift: ${shift},
              weekdays: [${days}]
            }
            isFood: ${isFood},
            isAccommodation: ${isAccommodation},
            isTransport:${isTransport},
            contact:{
              email:"${email}"
              phone:"${contact}"
            }
            )
          }
        }
      }`
    )
    if (response.error) {
      return false
    } else {
      return response.data.mutationWithAuth.fabricate.postMiniJob
    }
  }

  static async logout () {
    localStorage.removeItem('access-token')
    localStorage.removeItem('refresh-token')
    localStorage.removeItem('verify-token')
    UserService.__user = null
    return true
  }

  static async getUserbyId (id) {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `query{
        withAuth(token:"${accessToken}"){
          getUser(id:"${id}"){
            id
            emails {
              isPrimary
              address
            }
            phoneNumbers {
              isPrimary
              number
            }
            name {
              full
            }
            address {
              state
              address
              country
              city
              country
              pin
            }
            specialization {
              name
              id
            }
            numExperience {
              id
              name
            }
            workCity {
              id
              name
            }
            qualification {
              id
              name
            }
            professionalType {
              id
              name
            }
            profile {
              dob
              gender
              pan
              aadhar
              social {
                facebook
                linkedin
              }
              covid
              jobHistory {
                hospital
                department
                specialisation
                start
                end
              }
              education {
                course
                specialisation
                name
                year
              }
              references {
                name
                hospital
                designation
                phone
                email
              }
            }
            languageKnown {
              id
              name
            }
            additionalTraining {
              id
              name
            }
            workedOn {
              id
              softwarename
            }
            professionalRegistration {
              number
              registrationType {
                id
                name
              }
            }
            avatar {
              location
              fileName
              uri
              bucket
              region
              mimeType
              secureUrl
              url
              isSecured
              cdnUrl
            }
            correspondenceAddress {
              address
              city
              state
              pin
              country
            }
            departments {
              id
              name
            }
          }
         }
       }`
    )
    if (response.error) {
      return false
    } else {
      return response.data.withAuth.getUser
    }
  }

  static async listMiniJobBranches () {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `query{
        withAuth(token:"${accessToken}"){
          listMiniJobBranches{
            id
            jobLocation {
              hospitalName
              branchName
            }
         }
         }
       }`
    )
    if (response.error) {
      return false
    } else {
      return response.data.withAuth.listMiniJobBranches
    }
  }

  static async listMiniJobDepartments (branchId) {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `query{
        withAuth(token:"${accessToken}"){
          listMiniJobDepartments(branch:"${branchId}") {
            id
            departmentType{
              name
            }
          }
         }
       }`
    )
    if (response.error) {
      return false
    } else {
      return response.data.withAuth.listMiniJobDepartments
    }
  }

  static async listMiniJobProfessions (branchId, departmentId) {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `query{
        withAuth(token:"${accessToken}"){
          listMiniJobProfessions (branch:"${branchId}" department:"${departmentId}") {
            id
            name
          }
         }
       }`
    )
    if (response.error) {
      return false
    } else {
      return response.data.withAuth.listMiniJobProfessions
    }
  }

  static async listMiniJobQualifications (branchId, departmentId, professionId) {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `query{
        withAuth(token:"${accessToken}"){
          listMiniJobQualifications (branch:"${branchId}" 
                                    department:"${departmentId}"
                                    profession:"${professionId}"
          ) {
            id
            name
          }
         }
       }`
    )
    if (response.error) {
      return false
    } else {
      return response.data.withAuth.listMiniJobQualifications
    }
  }

  static async listMiniJobSpecializations (branchId, departmentId, professionId, qualificationId) {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `query{
        withAuth(token:"${accessToken}"){
          listMiniJobSpecializations (branch:"${branchId}" 
                                    department:"${departmentId}"
                                    profession:"${professionId}"
                                    qualification:"${qualificationId}"
          ) {
            id
            name
          }
         }
       }`
    )
    if (response.error) {
      return false
    } else {
      return response.data.withAuth.listMiniJobSpecializations
    }
  }

  static async listMiniJobExperiences (branchId, departmentId, professionId, qualificationId, specializationId) {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `query{
        withAuth(token:"${accessToken}"){
          listMiniJobExperiences (branch:"${branchId}" 
                                    department:"${departmentId}"
                                    profession:"${professionId}"
                                    qualification:"${qualificationId}"
                                    specialization: "${specializationId}"
          ) {
            id
            name
          }
         }
       }`
    )
    if (response.error) {
      return false
    } else {
      return response.data.withAuth.listMiniJobExperiences
    }
  }

  static async listMiniJobShifts (branchId, professionId) {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `query{
        withAuth(token:"${accessToken}"){
          listMiniJobShifts (branch:"${branchId}" profession:"${professionId}")
         }
       }`
    )
    if (response.error) {
      return false
    } else {
      return response.data.withAuth.listMiniJobShifts
    }
  }

  static async getStats () {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `query{
        withAuth(token:"${accessToken}"){
          getStatistics
         }
       }`
    )
    if (response.error) {
      return null
    } else {
      return response.data.withAuth.getStatistics
    }
  }
  
  static async getStatisticData (start, end) {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `query{
        withAuth(token:"${accessToken}"){
          getStatisticData(kind: POSTED, start: "${start}", end: "${end}") {
            x
            y
          }
         }
       }`
    )
    if (response.error) {
      return null
    } else {
      return response.data.withAuth.getStatisticData
    }
  }

  static async orgUsers () {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    const response = await api(
      `query{
        withAuth(token:"${accessToken}"){
          listOrganizationUsers {
            id
            email
            contact
            name
          }
         }
       }`
    )
    if (response.error) {
      return null
    } else {
      return response.data.withAuth.listOrganizationUsers
    }
  }

  static async verifyEmail (email) {
    const response = await api(
      `mutation {
        verifyEmail(email: "${email}")
      }`
    )
    if (response.error !== null) return response
    else {
      localStorage.setItem('email-verify-token', response.data.verifyEmail)
      return true
    }
  }

  static async verifyPhone (phone, resend) {
    const response = await api(
      `mutation {
        verifyPhone(contact: {
          code: "+91"
          mobile: "${phone}",
        },
        resend: ${resend}
        )
      }`
    )
    if (response.error !== null) return response
    else {
      localStorage.setItem('phone-verify-token', response.data.verifyPhone)
      return true
    }
  }

  static async verifyEmailOrPhone (emailorPhone, resend) {
    const response = await api(
      `query{
        loginWithOtp(emailOrPhone:"${emailorPhone}",resend:${resend})
      }`
    )
    if (response.error !== null) return response
    else {
      console.log('response.data.loginWithOtp:,', response.data.loginWithOtp)
      localStorage.setItem('emailorPhone-verify-token', response.data.loginWithOtp)
      return true
    }
  }

  static async verifyLoginWithEmailOrPhone (verifyToken, otp) {
    const response = await api(
      `mutation{
        verifyLogin(verifyToken:"${verifyToken}",otp:"${otp}"){
          accessToken
          verifyToken
          refreshToken
        }
      }`
    )
    if (response.error !== null) return false
    else {
      console.log('response::', response)
      localStorage.setItem('access-token', response.data.verifyLogin.accessToken)
      return true
    }
  }

  static async verifyEmailOtp (token, otp) {
    const response = await api(
      `mutation {
        verify(verifyToken: "${token}"
        otp:"${otp}"
        )
      }`
    )
    if (response.error !== null) return false
    else return true
  }

  static async verifyPhoneOtp (token, otp) {
    const response = await api(
      `mutation {
        verify(verifyToken: "${token}"
        otp:"${otp}"
        )
      }`
    )
    if (response.error !== null) return false
    else return true
  }

  static async requestVerify (email) {
    const response = await api(
      `{
         forgotPasswordHospital(email: "${email}")
        }`
    )
    if (response.error !== null) return false
    else {
      localStorage.setItem('password-token', response.data.forgotPasswordHospital)
      return true
    }
  }

  static async verify (token, otp) {
    const response = await api(
     `mutation{
        verifyHospital(verifyToken:"${token}"
        otp:"${otp}"
        )
      }`
    )
    if (response.error !== null) return false
    else {
      localStorage.setItem('reset-token', response.data.verifyHospital)
      return true
    }
  }

  static async resetPassword (resetToken, password) {
    const response = await api(
      `mutation {
            resetPassword(
                resetToken: "${resetToken}",
                password: "${password}"
            )
        }`
    )
    if (response.error !== null) return false
    else return response.data.resetPassword
  }

  static async preSignedUrl (filename) {
    const response = await api(
      `query{
        getSignedUrl(filename: "${filename}") {
          location
          fileName
          uri
          bucket
          region
          mimeType
          secureUrl
          url
          isSecured
          cdnUrl
        }
      }`
    )
    if (response.error) {
      return false
    } else {
      return response.data.getSignedUrl
    }
  }

  static async raiseAQueryMail (reason, description, jobId, jobDate, department, professionalName, professionalId) {
    const accessToken = localStorage.getItem('access-token')
    const response = await api(
      `mutation {
        mutationWithAuth(token: "${accessToken}") {
          update {
            raiseAQuery(reason: "${reason}", description: "${description}", jobId: "${jobId}", jobDate: "${jobDate}", department: "${department}", professionalName: "${professionalName}", professionalId: "${professionalId}")
            }
          }
        }`
    )
    if (response.error) {
      return false
    } else {
      return true
    }
  }

  static async updateCompany (logo, companyId) {
    const accessToken = localStorage.getItem('access-token')
    if (!accessToken) return false
    console.log(companyId)
    const response = await api(
      `mutation {
        mutationWithAuth(token: "${accessToken}") {
          update{
            updateCompany 
            (
              id: "${companyId}",
              logo: {
                location: ${logo.location},
                fileName: "${logo.fileName}",
                uri: "${logo.uri}",
                bucket: "${logo.bucket}",
                region: "${logo.region}",
                mimeType: "${logo.mimeType}",
                secureUrl: "${logo.secureUrl}",
                url: "${logo.url}",
                isSecured: ${logo.isSecured},
                cdnUrl: "${logo.cdnUrl}"
              }
            )
            {
              id
            }
          }
        }
      }`
    )
    if (response.error) {
      return false
    } else {
      return response.data.mutationWithAuth.update.updateCompany
    }
  }
}
